/* eslint-disable react/no-array-index-key */
import { useState , useEffect } from 'react'
import styles from './styles.module.sass'

const Discounts = (props) => {
    const {
        discounts,
        setListDiscounts,
        resetFilters,
    } = props

    const [ activeDiscounts, setActiveDiscounts ] = useState({})
    const [ arrayDiscounts, setArrayDiscounts ] = useState(null)
    
    const handleClick = (val) => {
        const discount = val

        if( activeDiscounts?.max === discount ){
            setActiveDiscounts({})
        }else{
            setActiveDiscounts( {
                max: val,
                min: 10
            } )
        }
    }

    useEffect(()=>{
        if(discounts){

            const arrayDisc = []
            const desc = Math.ceil(discounts?.max / 10)
            const descMax = desc * 10
            
            for(let init = 10; init <= descMax; init += 10) {
                arrayDisc.push(init)
            }
            setArrayDiscounts(arrayDisc)
        }
    },[discounts])

    useEffect(()=>{
        setListDiscounts(activeDiscounts)
    },[activeDiscounts])

    useEffect(()=>{
        if(resetFilters){
            setActiveDiscounts({})
        }
    },[resetFilters])


    return(
        <div className={styles?.contenidoCategorias}>

            <div className={styles?.seccionSuperior}>
                <p className={styles?.h2}>Descuentos</p>
            </div>

            <div className={styles?.iteracion}>
                <ul>
                    {arrayDiscounts?.map( descuento => (
                        <li key={`discount_${descuento}`} className={styles?.listTitles}>
                            <label 
                                className={styles?.labelClass} 
                                htmlFor={`discount_${descuento}`}
                            >Descuento del 10% al {descuento}%</label>
                            <input
                                className={styles?.radio} 
                                type="checkbox"
                                name="brand"
                                id={`discount_${descuento}`} 
                                onChange={() => handleClick(descuento)}
                                checked={ activeDiscounts?.max === descuento}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )   
}

export default Discounts